import { render } from "./UseinfoSliderImage.vue?vue&type=template&id=54a040c9&scoped=true&ts=true"
import script from "./UseinfoSliderImage.vue?vue&type=script&lang=ts"
export * from "./UseinfoSliderImage.vue?vue&type=script&lang=ts"

import "./UseinfoSliderImage.vue?vue&type=style&index=0&id=54a040c9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a040c9"]])

export default __exports__